import * as React from "react";
const SvgFiRrGolf = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-golf_svg__a)">
      <path
        fill="#062147"
        d="M12 10a20.3 20.3 0 0 0-4.016.4l-.006-2.285 5.009-2.076a2 2 0 0 0 .271-3.4 1 1 0 0 0-.1-.065L8.9.212A2 2 0 0 0 6 2v8.914C2.391 12.109 0 14.36 0 17c0 3.925 5.271 7 12 7s12-3.075 12-7-5.271-7-12-7m.073-5.745-4.1 1.7-.01-3.971zM12 22c-5.42 0-10-2.29-10-5 0-1.594 1.591-3.039 4-3.962V17a1 1 0 1 0 2 0l-.011-4.56A18.3 18.3 0 0 1 12 12c5.42 0 10 2.29 10 5s-4.58 5-10 5m5-5a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-golf_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGolf;
